import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationService} from '../../../services/notification.service';
import {MatDialog} from '@angular/material/dialog';
import {ScriptService} from '../../../services/script-service/script-service';
import {ClientService} from '../../../services/client.service';
import {ClientDTO} from '../../../model/clientDTO';
import {PaymentService} from '../../../services/payment-service';
import {environment} from '../../../../environments/environment';
import {DiscountDTO} from '../../../model/discountDTO';
import {CurrencyService} from '../../../services/currency-service';
import * as moment from 'moment';

declare let Stripe: any;
const options = {
  style: {
    base: {
      padding: '10px 12px',
      color: '#03738c',
      borderColor: 'blue',
      width: '400px',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      },
    },
  },
};

@Component({templateUrl: './select-payment-method.component.html', styleUrls: ['./select-payment-method.component.scss']})
export class SelectPaymentMethodComponent implements OnInit {

  client: ClientDTO;
  discount: DiscountDTO;
  amount: number;
  reportId: number;
  acceptedTerms = false;
  acceptedRecurringPayments = false;
  clientSecret: string;
  isBankPicked = false;
  year: number;
  clientCreatedAtYear: number;
  clientStartYear: number;

  private stripe: any;
  private idealBank: any;

  constructor(private service: PaymentService,
              private router: Router,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private notificationService: NotificationService,
              private scriptService: ScriptService,
              public currencyService: CurrencyService,
              private clientService: ClientService) {
  }

  ngOnInit(): void {
    this.getClient().then(() => this.service.prepare(this.client.id, this.reportId).subscribe(value => {
      this.clientSecret = value.clientSecret;
      this.discount = value.discount;
      this.amount = value.amount;
      this.year = value.year;
      this.loadStripeScript();
    }));
  }

  private loadStripeScript() {
    this.scriptService.loadScript('stripe')
      .then(() => {
        this.stripe = Stripe(environment.stripe.key);
        const elements = this.stripe.elements();
        this.idealBank = elements.create('idealBank', options);
        this.idealBank.mount('#ideal-bank-element');
        this.idealBank.on('change', () => this.isBankPicked = true);
      })
      .catch(() => {
        this.notificationService.warning('er is iets misgegaan, probeer het later opnieuw');
        this.router.navigate(['/']);
      });
  }

  private getClient(): Promise<void> {
    return new Promise<void>(resolve => {
      const getClient = clientId => this.clientService.getOne(clientId).subscribe(client => {
        this.client = client;
        this.clientCreatedAtYear = moment(this.client.createdAt, 'DD-MM-YYYY', true).year();
        this.clientStartYear = moment(this.client.startDate, 'DD-MM-YYYY', true).year();
        resolve();
      });
      this.route.params.subscribe(params => {
        getClient(params['clientId']);
        this.reportId = params['reportId'];
      });
    });
  }

  async pay() {
    if (!this.acceptedTerms || !this.isBankPicked) {
      return;
    }
    const {error} = await this.stripe.confirmIdealPayment(
      this.clientSecret,
      {
        payment_method: {ideal: this.idealBank},
        return_url: environment.stripe.redirectUrl + '/' + this.reportId,
      }
    );
    console.log(error);
  }
}
